<template>
    <form @submit.prevent="submit">
        <input-with-validation
            :value="email"
            :title="$t('fields.email')"
            :name="'email'"
            :style-class="'form-control'"
            :type="'email'"
            :errors="errors"
            :name-type="'label'"
            :use-u-i-d="true"
            @onInput="changeEmail"
            hide-label
        />

        <div>
            <input-with-validation
                :value="password"
                :title="$t('fields.password')"
                :name="'password'"
                :style-class="'form-control'"
                :type="'password'"
                :errors="errors"
                :name-type="'label'"
                :use-u-i-d="true"
                @onInput="changePassword"
                hide-label
            />


            <password v-model="password" @score="updatePasswordScore" :strength-meter-only="true"/>
            <span v-if="password && password.length > 0">{{password_strength_message}}</span>
        </div>

        <input-with-validation
            :value="password_confirmation"
            :title="$t('fields.password_confirmation')"
            :name="'password_confirmation'"
            :style-class="'form-control'"
            :type="'password'"
            :errors="errors"
            :name-type="'label'"
            :use-u-i-d="true"
            @onInput="changePasswordConfirmation"
            hide-label
        />

        <button type="button" class="btn btn-primary" @click.prevent="submit" :disabled="loading">
            <span v-if="!loading">
                {{ $t('general.reset_password')}}
            </span>

            <div class="spinner-border loading-spinner" role="status" v-if="loading">
                <span class="sr-only"></span>
            </div>
        </button>
    </form>
</template>

<script>
    export default {
        name: "ResetPasswordComponent",
        props: {
            token: {
                type: String
            },
        },
        data() {
            return {
                email: null,
                password: null,
                password_confirmation: null,
                errors: null,
                password_strength_message: '',
                loading: false,
            }
        },
        methods: {
            submit() {
                var app = this;
                app.errors = null;
                app.loading = true;
                axios.post('password/reset', {
                    token: app.token,
                    password: app.password,
                    password_confirmation: app.password_confirmation,
                    email: app.email,
                }).then(response => {
                    window.location.href = "/";
                }).catch(error => {
                    app.$notify({
                        group: "system",
                        title: this.$t('general.request_failed'),
                        text: error.response.data.error_message ? error.response.data.error_message : this.$t('general.some_fields_failed_validation'),
                        type: "warn"
                    });
                    app.errors = error.response.data.errors;
                }).finally(() => {
                    app.loading = false;
                });
            },
            updatePasswordScore(score) {
                this.password_strength_message = this.$t('auth.password_strength_'+parseInt(score),'');
            },
            changeEmail(event)
            {
                this.email = event.target.value;
            },
            changePassword(event)
            {
                this.password = event.target.value;
            },
            changePasswordConfirmation(event)
            {
                this.password_confirmation = event.target.value;
            },
        },
    }
</script>
